import React, { FC, useCallback } from 'react';
import { Modal, Title, Checkbox } from 'ui-library';
import { PlanDataChangeFormModalProps } from './PlanDataChangeFormModalProps.types';
import './PlanDataChangeFormModal.css';

const PlanDataChangeFormModal: FC<PlanDataChangeFormModalProps> = (props) => {
    const {
        width,
        visible,
        closable,
        hasBorderRadius,
        okButtonProps,
        closeIcon,
        resources,
        toggleChecked,
        // Event handlers
        onOk,
        onCancel,
        onToggleChange,
    } = props;

    const handleCheckboxChange = useCallback((checked: boolean) => {
        if (onToggleChange) {
            onToggleChange(checked);
        }
    }, [onToggleChange]);

    return (
        <Modal
            className={resources.modalClass}
            keyboard={false}
            maskClosable={false}
            width={width}
            visible={visible}
            okText={resources.okText}
            cancelText={resources.cancelText}
            closable={closable}
            borderRadius={hasBorderRadius}
            okButtonProps={okButtonProps}
            closeIcon={closeIcon}
            onOk={onOk}
            onCancel={onCancel}
        >
            <Title type={2} className="mb-24">
                {resources.title}
            </Title>
            <div className="plan-data-change-form-modal-content">
                <div>
                    {resources.infoText}
                </div>
                <div className="mt-10">
                    <Checkbox checked={toggleChecked} label={resources.checkBoxLabel} onChange={(e) => handleCheckboxChange(e.target.checked)} />
                </div>
            </div>
        </Modal>
    );
};

export default PlanDataChangeFormModal;
